import { MorphCards } from '@/Components/ui/morph-card'
import { useSafeTranslation } from '@/hooks/use-safe-translation'
import { cn } from '@/lib/utils'
import type { Bundle } from '@/types'
import { PlanCard } from './plan-card'

/**
 * The plans and bundles reserved for card holders.
 *
 * They are our own, read from the site's copy of each, and drawn with
 * everything the plan cards elsewhere on the site show for them.
 */
export function TelcoTab({ offers }: { offers: Bundle[] }) {
  const t = useSafeTranslation()

  if (offers.length === 0) {
    return <p className="py-16 text-center text-muted-foreground">{t('vipCard.noOffers')}</p>
  }

  return (
    <MorphCards
      className={cn(
        'grid gap-4',
        offers.length > 3
          ? 'grid-cols-[repeat(auto-fit,minmax(280px,1fr))]'
          : 'grid-cols-[repeat(auto-fit,minmax(280px,350px))]'
      )}
    >
      {offers.map((offer) => (
        <PlanCard key={String(offer.id)} plan={offer} />
      ))}
    </MorphCards>
  )
}
